import { useState } from "react";
import { validarJustificativaDominante } from "../../../hooks/nova-obra.tipos";
import type { AlterarDominanteDialogProps } from "./types-alterar-dominante-dialog";

export function useAlterarDominanteDialog({
  atual,
  novo,
  onConfirm,
  onCancel,
}: AlterarDominanteDialogProps) {
  const [justificativa, setJustificativa] = useState("");
  const [tentou, setTentou] = useState(false);

  const erro = validarJustificativaDominante(justificativa);
  const mostrarErro = tentou && erro !== null;

  const alterarJustificativa = (valor: string) => setJustificativa(valor);

  const confirmar = () => {
    if (erro) {
      setTentou(true);
      return;
    }
    onConfirm(justificativa);
  };

  return {
    justificativa,
    alterarJustificativa,
    erro,
    mostrarErro,
    confirmar,
    atual,
    novo,
    onCancel,
  };
}
